import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import {
  ExtraErrorData as ExtraErrorDataIntegration,
  HttpClient
} from '@sentry/integrations'
const isProd = process.env.NODE_ENV === 'production'

export const initSentry = () => {
  let integrations: any[] = [
    new Sentry.Integrations.Breadcrumbs({
      console: false
    }),
    new BrowserTracing()
  ]

  if (isProd) {
    integrations = [
      ...integrations,
      new ExtraErrorDataIntegration({
        depth: 10
      }),
      new HttpClient({
        failedRequestStatusCodes: [
          [500, 599],
          [400, 499]
        ],
        failedRequestTargets: [/.*availroom\.com.*/g]
      })
    ]
  }

  Sentry.init({
    dsn: 'https://ebe6f321da444ca58bd1b7ae60c50656@o1290103.ingest.sentry.io/6759085',
    integrations,
    environment: process.env.NODE_ENV,
    // ...(isProd && {
    //   replaysSessionSampleRate: 1.0,
    //   replaysOnErrorSampleRate: 1.0
    // }),
    tracesSampleRate: 1.0,
    ignoreErrors: ['canceled', 'ERR_CANCELED', 'CanceledError'],
    sendDefaultPii: true,
    normalizeDepth: 10
  })
}

export default Sentry
